import { getAccessToken } from "../utils/accessToken";

const { REACT_APP_SERVER_URL } = process.env;

const GET_PARAMS = {
  method: "GET",
  mode: "cors",
  headers: {
    Authorization: `Bearer ${getAccessToken()}`
  }
};

const DELETE_PARAMS = body => {
  let params = {
    method: "DELETE",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getAccessToken()}`
    }
  };
  if (body && Object.keys(body).length) {
    params["body"] = JSON.stringify(body);
  }

  return params;
};

const PATCH_PARAMS = body => ({
  method: "PATCH",
  mode: "cors",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAccessToken()}`
  },
  body: JSON.stringify(body)
});

const POST_PARAMS = body => ({
  method: "POST",
  mode: "cors",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAccessToken()}`
  },
  body: JSON.stringify(body)
});

export const loadUserProfile = () =>
  fetch(`${REACT_APP_SERVER_URL}/me/profile`, GET_PARAMS);

export const loadAdminUsers = (page, query) =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/users?page=${page}&q=${query}`,
    GET_PARAMS
  );

export const loadSingleUser = id =>
  fetch(`${REACT_APP_SERVER_URL}/admin/users/${id}`, GET_PARAMS);

export const deleteUserDashboard = (userId, userDashboardId, dashboardId) =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/users/${userDashboardId}`,
    DELETE_PARAMS({ userId, dashboardId })
  );

export const updateUserDashboard = (
  userId,
  userDashboardId,
  dashboardId,
  filterIds
) =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/users/${userDashboardId}`,
    PATCH_PARAMS({ userId, dashboardId, filterIds })
  );

export const addNewUserDashboards = (
  userId,
  dashboardFilters,
  notifyUser,
  notifyFinance
) =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/users/`,
    POST_PARAMS({ userId, dashboardFilters, notifyUser, notifyFinance })
  );

export const inviteUser = body =>
  fetch(`${REACT_APP_SERVER_URL}/admin/users/invite`, POST_PARAMS(body));

export const loadRegistrations = () =>
  fetch(`${REACT_APP_SERVER_URL}/admin/registrations`, GET_PARAMS);

export const loadRegistration = id =>
  fetch(`${REACT_APP_SERVER_URL}/admin/registrations/${id}`, GET_PARAMS);

export const resetPassword = (body, code) => {
  body = { ...body, application: "samba-data-analytics" };
  return fetch(
    `${REACT_APP_SERVER_URL}/forgotPassword/set?code=${code}`,
    POST_PARAMS(body)
  );
};

export const updateRegistration = body =>
  fetch(`${REACT_APP_SERVER_URL}/admin/registrations`, PATCH_PARAMS(body));

export const loadAdminDashboards = query =>
  fetch(`${REACT_APP_SERVER_URL}/admin/dashboards?${query}`, GET_PARAMS);

export const loadAllAdminDashboards = query =>
  fetch(`${REACT_APP_SERVER_URL}/admin/dashboards?all=true`, GET_PARAMS);

export const loadAdminDashboard = id =>
  fetch(`${REACT_APP_SERVER_URL}/admin/dashboards/${id}`, GET_PARAMS);

export const addNewAdminDashboard = body =>
  fetch(`${REACT_APP_SERVER_URL}/admin/dashboards`, POST_PARAMS(body));

export const updateDashboard = (id, body) =>
  fetch(`${REACT_APP_SERVER_URL}/admin/dashboards/${id}`, PATCH_PARAMS(body));

export const getAdminDashboardCampaigns = () =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/dashboards/distinct/campaignName`,
    GET_PARAMS
  );

export const getAdminDashboardCreators = () =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/dashboards/distinct/creator`,
    GET_PARAMS
  );

export const forgotPassword = body => {
  body = { ...body, application: "samba-data-analytics" };
  return fetch(
    `${REACT_APP_SERVER_URL}/forgotpassword/request`,
    POST_PARAMS(body)
  );
};

export const deleteDashboard = id =>
  fetch(`${REACT_APP_SERVER_URL}/admin/dashboards/${id}`, DELETE_PARAMS());

export const updateFilter = (id, body) =>
  fetch(`${REACT_APP_SERVER_URL}/admin/filters/${id}`, PATCH_PARAMS(body));

export const deleteFilter = id =>
  fetch(`${REACT_APP_SERVER_URL}/admin/filters/${id}`, DELETE_PARAMS());

export const addNewFilter = body =>
  fetch(`${REACT_APP_SERVER_URL}/admin/filters`, POST_PARAMS(body));

export const checkPermissionDelete = id =>
  fetch(`${REACT_APP_SERVER_URL}/admin/filters/check-delete/${id}`, GET_PARAMS);

export const loadCampaigns = (type = "trf") =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/console/campaigns?type=${type}`,
    GET_PARAMS
  );

export const register = body => {
  body = { ...body, application: "samba-data-analytics" };
  return fetch(`${REACT_APP_SERVER_URL}/register`, {
    method: "POST",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });
};

export const loadPeriscopeUrl = body =>
  fetch(`${REACT_APP_SERVER_URL}/admin/periscopeUrl`, POST_PARAMS(body));

export const updateUserRole = body =>
  fetch(`${REACT_APP_SERVER_URL}/admin/users/update-role`, POST_PARAMS(body));

export const loadGroupPermissions = () =>
  fetch(`${REACT_APP_SERVER_URL}/admin/groupPermissions`, GET_PARAMS);

export const addNewGroupPermission = body =>
  fetch(`${REACT_APP_SERVER_URL}/admin/groupPermissions`, POST_PARAMS(body));

export const updateGroupPermission = (id, body) =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/groupPermissions/${id}`,
    PATCH_PARAMS(body)
  );

export const deleteGroupPermission = id =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/groupPermissions/${id}`,
    DELETE_PARAMS()
  );

export const updateUserApplications = (userId, body) =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/usersApplications/${userId}`,
    PATCH_PARAMS(body)
  );

export const getUserApplications = userId =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/usersApplications/${userId}`,
    GET_PARAMS
  );

export const getOutages = () =>
  fetch(`${REACT_APP_SERVER_URL}/admin/outages`, GET_PARAMS);

export const updateOutages = (application, body) =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/outages/${application}`,
    PATCH_PARAMS(body)
  );

export const getAcrOutages = query =>
  fetch(`${REACT_APP_SERVER_URL}/admin/acr-outages?${query}`, GET_PARAMS);

export const getAcrOutageCountries = () =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/acr-outages/channel_country`,
    GET_PARAMS
  );

export const getAcrOutageCallsigns = () =>
  fetch(`${REACT_APP_SERVER_URL}/admin/acr-outages/callsign`, GET_PARAMS);

export const getCapturedChannels = query =>
  fetch(`${REACT_APP_SERVER_URL}/admin/captured-channels?${query}`, GET_PARAMS);

export const getCapturedChannelsCountries = () =>
  fetch(
    `${REACT_APP_SERVER_URL}/admin/captured-channels/countries`,
    GET_PARAMS
  );

export const getAcrQueries = () =>
  fetch(`${REACT_APP_SERVER_URL}/admin/acr-queries`, GET_PARAMS);

export const addAcrQuery = body =>
  fetch(`${REACT_APP_SERVER_URL}/admin/acr-queries`, POST_PARAMS(body));

export const updateAcrQuery = (id, body) =>
  fetch(`${REACT_APP_SERVER_URL}/admin/acr-queries/${id}`, PATCH_PARAMS(body));

export const deleteAcrQuery = id =>
  fetch(`${REACT_APP_SERVER_URL}/admin/acr-queries/${id}`, DELETE_PARAMS());

export const getDashboardBrandings = () =>
  fetch(`${REACT_APP_SERVER_URL}/admin/dashboards/branding`, GET_PARAMS);

export const getTopChannels = () =>
  fetch(`${REACT_APP_SERVER_URL}/admin/topChannels`, GET_PARAMS);

export const addNewTopChannel = body =>
  fetch(`${REACT_APP_SERVER_URL}/admin/topChannels`, POST_PARAMS(body));

export const updateTopChannel = (id, body) =>
  fetch(`${REACT_APP_SERVER_URL}/admin/topChannels/${id}`, PATCH_PARAMS(body));

export const deleteTopChannel = id =>
  fetch(`${REACT_APP_SERVER_URL}/admin/topChannels/${id}`, DELETE_PARAMS());
